var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectSectionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.45374C6.5 7.83483 6.74586 7.24126 7.1835 6.80362C7.62114 6.36598 8.21471 6.12012 8.83362 6.12012H16.4164C16.7228 6.12012 17.0263 6.18048 17.3094 6.29775C17.5925 6.41503 17.8498 6.58692 18.0665 6.80362C18.2832 7.02032 18.4551 7.27757 18.5724 7.5607C18.6896 7.84383 18.75 8.14729 18.75 8.45374V16.0365C18.75 16.3429 18.6896 16.6464 18.5724 16.9295C18.4551 17.2127 18.2832 17.4699 18.0665 17.6866C17.8498 17.9033 17.5925 18.0752 17.3094 18.1925C17.0263 18.3098 16.7228 18.3701 16.4164 18.3701H8.83362C8.52717 18.3701 8.22371 18.3098 7.94059 18.1925C7.65746 18.0752 7.4002 17.9033 7.1835 17.6866C6.96681 17.4699 6.79491 17.2127 6.67764 16.9295C6.56036 16.6464 6.5 16.3429 6.5 16.0365V8.45374Z",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8855 14.64C3.61687 14.4874 3.39344 14.2663 3.23791 13.9994C3.08238 13.7324 3.0003 13.4291 3 13.1201V4.37012C3 3.40762 3.7875 2.62012 4.75 2.62012H13.5C14.1562 2.62012 14.5132 2.95699 14.8125 3.49512",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2451H15.25",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 9.62012V14.8701",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectSectionsIcon);
export default __webpack_public_path__ + "static/media/collect-sections-icon.ff82430612a187ddfc6c1baaa97651ee.svg";
export { ForwardRef as ReactComponent };